module.exports = __webpack_public_path__ + "static/media/pj-plus.5cf36685.svg";